module.exports = __webpack_public_path__ + "static/media/bateau_poisson_plante.dd485893.png";